import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const AdSuccess = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [tx, setTx] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      navigate("/dashboard/ads");
      return;
    }
    let attempts = 0;
    const maxAttempts = 8;
    const interval = setInterval(async () => {
      attempts += 1;
      try {
        const res = await api.get(`/ads/status/${sessionId}`);
        setTx(res.data);
        if (res.data.payment_status === "paid") { setStatus("paid"); clearInterval(interval); }
        else if (res.data.status === "expired") { setStatus("expired"); clearInterval(interval); }
        else if (attempts >= maxAttempts) { setStatus("timeout"); clearInterval(interval); }
      } catch (e) {
        if (attempts >= maxAttempts) { setStatus("error"); clearInterval(interval); }
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [sessionId, navigate]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-20 text-center" data-testid="ad-success-page">
      {status === "polling" && (
        <>
          <Loader2 className="w-16 h-16 mx-auto animate-spin text-primary" />
          <h1 className="font-heading text-3xl font-black mt-6">Memverifikasi pembayaran...</h1>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-20 h-20 mx-auto text-green-600" />
          <h1 className="font-heading text-4xl font-black mt-6" data-testid="ad-success-title">Banner Aktif!</h1>
          <p className="text-muted-foreground mt-2">Banner kamu akan tayang di slot yang dipilih. Tracking impressions & clicks bisa dilihat di dashboard.</p>
          <div className="flex gap-3 justify-center mt-8">
            <Button onClick={() => navigate("/dashboard/ads")} variant="outline" className="rounded-full">Lihat Banner Saya</Button>
            <Button onClick={() => navigate("/")} className="rounded-full">Ke Homepage</Button>
          </div>
        </>
      )}
      {(status === "expired" || status === "timeout" || status === "error") && (
        <>
          <XCircle className="w-20 h-20 mx-auto text-destructive" />
          <h1 className="font-heading text-3xl font-black mt-6">Pembayaran tidak berhasil</h1>
          <Button onClick={() => navigate("/dashboard/ads")} className="rounded-full mt-6">Coba Lagi</Button>
        </>
      )}
    </div>
  );
};

export default AdSuccess;
